<!--公告及新闻稿-->
<template>
  <!--内容-->
  <div class="content_width_box">
    <div class="tishixiaoxi">
      <span v-html="$t('investor.report.notice')"></span>
      <br><br>
      <div class="little" v-html="$t('investor.report.noticeFoot')"></div>
    </div>
    <div class="content_title">
      <div class="title_left_h2">{{ $t('investor.report.title') }}</div>
      <div class="title_right_tab">
        <div class="tab1" @click="clickTab('公告')">{{ $t('investor.report.tabs.announcement') }}</div>
        <div class="tab2" @click="clickTab('新闻稿')">{{ $t('investor.report.tabs.news') }}</div>
      </div>
    </div>
    <div class="select_box">
      <multiselect v-show="selectedItem == '公告'" v-model="yearSelected" 
        :options="newsYearOptions" 
        :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('investor.report.yearPlaceholder')"></multiselect>
      <multiselect v-show="selectedItem == '新闻稿'" v-model="yearNoticeSelected" 
      :options="noticeYearOptions" 
      :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('investor.report.yearPlaceholder')"></multiselect>
    </div>
    <YearsTitleListView v-show="selectedItem == '公告'" :messageList="conditionNewsList.list" :perPage="conditionNewsList.perPage" :yearSelected="yearSelected"></YearsTitleListView>
    <YearsTitleListView v-show="selectedItem == '新闻稿'" :messageList="conditionNoticeList.list" :perPage="conditionNoticeList.perPage" :yearSelected="yearNoticeSelected"></YearsTitleListView>
  </div>  
</template>
<script>

import YearsTitleListView from '../../titleNews/YearsTitleListView'
import UtilEvent from '../../utils/UtilEvent.js'
  export default {
    name: 'investorReport',
    components:{UtilEvent,YearsTitleListView},
    props: ['conditionNewsList',],
    created(){
        
    },
    data () {
      return {
        yearSelected:'全部年份',
        yearNoticeSelected:'全部年份',
        selectedItem:'公告',
        conditionNoticeList:{total:0,perPage:1,yearList:[],list:[]}
      }
    },
    computed:{
      newsYearOptions() {
        let years = this.conditionNewsList && this.conditionNewsList.yearList ? this.conditionNewsList.yearList : [];
        return ['全部年份', ...years];
      },
      noticeYearOptions() {
        let years = this.conditionNoticeList && this.conditionNoticeList.yearList ? this.conditionNoticeList.yearList : [];
        return ['全部年份', ...years];
      }
    },
    methods:{
      clickTab(item){
        this.selectedItem = item;
        if(item == '新闻稿'){
          new UtilEvent().getNoticeListData(this)
        }
      },
      reloadNoticeData(){
        new UtilEvent().getNoticeListData(this)
      }
    },
    watch:{
      
    },
    mounted(){
      
    },
   
  }
  </script>
